import React, { useContext } from "react";
import Render from "../pages/canvas/paper/render";
import DND from "../pages/canvas/paper/dndhandler";

export default function Page(props) {
  return (
    <div style={{ position: "relative" }} ref={props.editorRef}>
      <div
        style={{
          position: "relative",
          minHeight: 700,
          display: "flex",
          flexDirection: "column",
          backgroundColor: props.block.props.backgroundColor,
          alignItems: props.block.props.alignItems,
        }}
      >
        {props.children.map((block, index) => {
          const path = [];
          path.push(index);

          return (
            <DND key={block.id} block={block} path={path} index={index}>
              <Render />
            </DND>
          );
        })}
      </div>
      {/* <div style={{ padding: 10, display: "flex", justifyContent: "center" }}>
        <div
          style={{
            border: "2px dashed #E0E0E0",
            fontFamily: "var(--font)",
            borderRadius: 5,
            padding: 20,
            textAlign: "center",
            width: "100%",
          }}
        >
          Drop New Element Here
        </div>
      </div> */}
    </div>
  );
}
